export default function demoPage() {
  var demoFeatured = document.getElementById('demo-featured-screenshot'),
      demoScreenshots = document.querySelectorAll('.demo-screenshots .demo-screenshot');
  
  if (demoFeatured && demoScreenshots) {
    demoScreenshots.forEach((demoScreenshot) => {
      demoScreenshot.addEventListener('click', () => {
        var activeSrc = demoScreenshot.dataset.src,
            demoFeaturedImg = demoFeatured.querySelector('img');
        
        // check if already active
        if (activeSrc !== demoFeaturedImg.dataset.src) {
          var prevActive = document.querySelector('.demo-screenshots .demo-screenshot.active');
          
          // if not, remove old active class
          prevActive.classList.remove('active');
          // fade out
          demoFeaturedImg.style.opacity = 0;
          setTimeout(function() {
            // fade back in
            demoFeaturedImg.style.opacity = 1;
            // set featured src to new screenshot
            demoFeaturedImg.setAttribute('src', activeSrc);
            // add active class to new screenshot
            demoScreenshot.classList.add('active');
          }, 100);
        }
      });
    });
  }
}